import React, { createContext, useContext, useState, useEffect } from 'react';

// Supported languages
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];

// Translations
export const translations = {
  en: {
    // Navigation
    home: 'Home',
    liveTV: 'Live TV',
    guide: 'Guide',
    library: 'Library',
    freeTV: 'Free TV',
    cbxtra: 'CBXtra',
    search: 'Search',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    profile: 'Profile',
    myList: 'My List',
    
    // Content
    movies: 'Movies',
    tvShows: 'TV Shows',
    channels: 'Channels',
    featured: 'Featured',
    continueWatching: 'Continue Watching',
    recommendations: 'Recommended for You',
    similar: 'Similar Content',
    watchlist: 'Watchlist',
    favorites: 'Favorites',
    
    // Actions
    play: 'Play',
    addToWatchlist: 'Add to Watchlist',
    removeFromWatchlist: 'Remove from Watchlist',
    addToFavorites: 'Add to Favorites',
    removeFromFavorites: 'Remove from Favorites',
    share: 'Share',
    subscribe: 'Subscribe',
    
    // Player
    playing: 'Now Playing',
    nextEpisode: 'Next Episode',
    episodes: 'Episodes',
    season: 'Season',
    backToBrowse: 'Back to Browse',
    
    // Reviews
    reviews: 'Reviews',
    writeReview: 'Write a Review',
    submitReview: 'Submit Review',
    noReviews: 'No reviews yet. Be the first to review!',
    helpful: 'Helpful',
    
    // Auth
    email: 'Email',
    password: 'Password',
    name: 'Name',
    loginWithGoogle: 'Continue with Google',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    analytics: 'Analytics',
    contentManagement: 'Content Management',
    subscribers: 'Subscribers',
    settings: 'Settings',
    
    // Misc
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    noResults: 'No results found',
    viewAll: 'View All',
    learnMore: 'Learn More',
    
    // Footer
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    language: 'Language',
  },
  es: {
    // Navigation
    home: 'Inicio',
    liveTV: 'TV en Vivo',
    guide: 'Guía',
    library: 'Biblioteca',
    freeTV: 'TV Gratis',
    cbxtra: 'CBXtra',
    search: 'Buscar',
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    signOut: 'Cerrar Sesión',
    profile: 'Perfil',
    myList: 'Mi Lista',
    
    // Content
    movies: 'Películas',
    tvShows: 'Series',
    channels: 'Canales',
    featured: 'Destacados',
    continueWatching: 'Continuar Viendo',
    recommendations: 'Recomendado para Ti',
    similar: 'Contenido Similar',
    watchlist: 'Lista de Seguimiento',
    favorites: 'Favoritos',
    
    // Actions
    play: 'Reproducir',
    addToWatchlist: 'Agregar a Lista',
    removeFromWatchlist: 'Quitar de Lista',
    addToFavorites: 'Agregar a Favoritos',
    removeFromFavorites: 'Quitar de Favoritos',
    share: 'Compartir',
    subscribe: 'Suscribirse',
    
    // Player
    playing: 'Reproduciendo',
    nextEpisode: 'Siguiente Episodio',
    episodes: 'Episodios',
    season: 'Temporada',
    backToBrowse: 'Volver',
    
    // Reviews
    reviews: 'Reseñas',
    writeReview: 'Escribir Reseña',
    submitReview: 'Enviar Reseña',
    noReviews: 'Sin reseñas aún. ¡Sé el primero!',
    helpful: 'Útil',
    
    // Auth
    email: 'Correo',
    password: 'Contraseña',
    name: 'Nombre',
    loginWithGoogle: 'Continuar con Google',
    createAccount: 'Crear Cuenta',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    dontHaveAccount: '¿No tienes cuenta?',
    
    // Admin
    adminDashboard: 'Panel de Admin',
    analytics: 'Analíticas',
    contentManagement: 'Gestión de Contenido',
    subscribers: 'Suscriptores',
    settings: 'Configuración',
    
    // Misc
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    noResults: 'Sin resultados',
    viewAll: 'Ver Todo',
    learnMore: 'Más Info',
    
    // Footer
    aboutUs: 'Sobre Nosotros',
    contactUs: 'Contacto',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    language: 'Idioma',
  },
  fr: {
    // Navigation
    home: 'Accueil',
    liveTV: 'TV en Direct',
    guide: 'Guide',
    library: 'Bibliothèque',
    freeTV: 'TV Gratuite',
    cbxtra: 'CBXtra',
    search: 'Rechercher',
    signIn: 'Connexion',
    signUp: 'Inscription',
    signOut: 'Déconnexion',
    profile: 'Profil',
    myList: 'Ma Liste',
    
    // Content
    movies: 'Films',
    tvShows: 'Séries',
    channels: 'Chaînes',
    featured: 'En Vedette',
    continueWatching: 'Continuer à Regarder',
    recommendations: 'Recommandé pour Vous',
    similar: 'Contenu Similaire',
    watchlist: 'Liste de Suivi',
    favorites: 'Favoris',
    
    // Actions
    play: 'Lire',
    addToWatchlist: 'Ajouter à la Liste',
    removeFromWatchlist: 'Retirer de la Liste',
    addToFavorites: 'Ajouter aux Favoris',
    removeFromFavorites: 'Retirer des Favoris',
    share: 'Partager',
    subscribe: "S'abonner",
    
    // Player
    playing: 'En Lecture',
    nextEpisode: 'Épisode Suivant',
    episodes: 'Épisodes',
    season: 'Saison',
    backToBrowse: 'Retour',
    
    // Reviews
    reviews: 'Avis',
    writeReview: 'Écrire un Avis',
    submitReview: 'Soumettre',
    noReviews: 'Pas encore d\'avis. Soyez le premier!',
    helpful: 'Utile',
    
    // Auth
    email: 'Email',
    password: 'Mot de Passe',
    name: 'Nom',
    loginWithGoogle: 'Continuer avec Google',
    createAccount: 'Créer un Compte',
    alreadyHaveAccount: 'Déjà un compte?',
    dontHaveAccount: 'Pas de compte?',
    
    // Admin
    adminDashboard: 'Tableau de Bord Admin',
    analytics: 'Analytiques',
    contentManagement: 'Gestion du Contenu',
    subscribers: 'Abonnés',
    settings: 'Paramètres',
    
    // Misc
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    noResults: 'Aucun résultat',
    viewAll: 'Voir Tout',
    learnMore: 'En Savoir Plus',
    
    // Footer
    aboutUs: 'À Propos',
    contactUs: 'Contact',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: "Conditions d'Utilisation",
    language: 'Langue',
  },
  pt: {
    // Navigation
    home: 'Início',
    liveTV: 'TV ao Vivo',
    guide: 'Guia',
    library: 'Biblioteca',
    freeTV: 'TV Grátis',
    cbxtra: 'CBXtra',
    search: 'Pesquisar',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    signOut: 'Sair',
    profile: 'Perfil',
    myList: 'Minha Lista',
    
    // Content
    movies: 'Filmes',
    tvShows: 'Séries',
    channels: 'Canais',
    featured: 'Destaques',
    continueWatching: 'Continuar Assistindo',
    recommendations: 'Recomendado para Você',
    similar: 'Conteúdo Similar',
    watchlist: 'Lista de Interesse',
    favorites: 'Favoritos',
    
    // Actions
    play: 'Reproduzir',
    addToWatchlist: 'Adicionar à Lista',
    removeFromWatchlist: 'Remover da Lista',
    addToFavorites: 'Adicionar aos Favoritos',
    removeFromFavorites: 'Remover dos Favoritos',
    share: 'Compartilhar',
    subscribe: 'Inscrever-se',
    
    // Player
    playing: 'Reproduzindo',
    nextEpisode: 'Próximo Episódio',
    episodes: 'Episódios',
    season: 'Temporada',
    backToBrowse: 'Voltar',
    
    // Reviews
    reviews: 'Avaliações',
    writeReview: 'Escrever Avaliação',
    submitReview: 'Enviar Avaliação',
    noReviews: 'Sem avaliações ainda. Seja o primeiro!',
    helpful: 'Útil',
    
    // Auth
    email: 'Email',
    password: 'Senha',
    name: 'Nome',
    loginWithGoogle: 'Continuar com Google',
    createAccount: 'Criar Conta',
    alreadyHaveAccount: 'Já tem conta?',
    dontHaveAccount: 'Não tem conta?',
    
    // Admin
    adminDashboard: 'Painel Admin',
    analytics: 'Análises',
    contentManagement: 'Gestão de Conteúdo',
    subscribers: 'Inscritos',
    settings: 'Configurações',
    
    // Misc
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    noResults: 'Sem resultados',
    viewAll: 'Ver Tudo',
    learnMore: 'Saiba Mais',
    
    // Footer
    aboutUs: 'Sobre Nós',
    contactUs: 'Contato',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    language: 'Idioma',
  },
  de: {
    // Navigation
    home: 'Startseite',
    liveTV: 'Live-TV',
    guide: 'TV-Guide',
    library: 'Bibliothek',
    freeTV: 'Gratis TV',
    cbxtra: 'CBXtra',
    search: 'Suchen',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signOut: 'Abmelden',
    profile: 'Profil',
    myList: 'Meine Liste',
    
    // Content
    movies: 'Filme',
    tvShows: 'Serien',
    channels: 'Kanäle',
    featured: 'Empfohlen',
    continueWatching: 'Weiterschauen',
    recommendations: 'Empfehlungen für Sie',
    similar: 'Ähnliche Inhalte',
    watchlist: 'Merkliste',
    favorites: 'Favoriten',
    
    // Actions
    play: 'Abspielen',
    addToWatchlist: 'Zur Merkliste',
    removeFromWatchlist: 'Von Merkliste entfernen',
    addToFavorites: 'Zu Favoriten',
    removeFromFavorites: 'Von Favoriten entfernen',
    share: 'Teilen',
    subscribe: 'Abonnieren',
    
    // Player
    playing: 'Wird abgespielt',
    nextEpisode: 'Nächste Episode',
    episodes: 'Episoden',
    season: 'Staffel',
    backToBrowse: 'Zurück',
    
    // Reviews
    reviews: 'Bewertungen',
    writeReview: 'Bewertung schreiben',
    submitReview: 'Absenden',
    noReviews: 'Noch keine Bewertungen. Schreiben Sie die erste!',
    helpful: 'Hilfreich',
    
    // Auth
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Name',
    loginWithGoogle: 'Mit Google fortfahren',
    createAccount: 'Konto erstellen',
    alreadyHaveAccount: 'Bereits ein Konto?',
    dontHaveAccount: 'Noch kein Konto?',
    
    // Admin
    adminDashboard: 'Admin-Dashboard',
    analytics: 'Analysen',
    contentManagement: 'Inhaltsverwaltung',
    subscribers: 'Abonnenten',
    settings: 'Einstellungen',
    
    // Misc
    loading: 'Wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    noResults: 'Keine Ergebnisse',
    viewAll: 'Alle anzeigen',
    learnMore: 'Mehr erfahren',
    
    // Footer
    aboutUs: 'Über uns',
    contactUs: 'Kontakt',
    privacyPolicy: 'Datenschutz',
    termsOfService: 'Nutzungsbedingungen',
    language: 'Sprache',
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Try to get from localStorage, default to 'en'
    const saved = localStorage.getItem('cbxtv_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('cbxtv_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const currentLanguage = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  const value = {
    language,
    setLanguage,
    t,
    currentLanguage,
    languages: LANGUAGES,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
